import { connect } from 'react-redux';
import Top10 from '../components/Top10HomeComponent';
import { getTop10DataIfNeeded } from '../actions/Top10Actions';

const mapStateToProps = (state) => ({
    dataTop10: state.top10.dataTop10,
    dataCategories: state.top10.dataCategories,
    // isMobile: state.breakpointReducer.isSmall || state.breakpointReducer.isExtraSmall,
    isLoading: state.top10.isLoading,
    notFound: state.top10.notFound,
});

const mapDispatchToProps = (dispatch) => ({
    getTop10DataIfNeeded: (idCategory = 1) => {
        dispatch(getTop10DataIfNeeded(idCategory));
    },
});


const Top10Container = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Top10);

export default Top10Container;
